export const SUPERSET_BASE_Features = {
    /**
     * 产品新功能superset dashboard
     */
    SUPERSET_NEW_FEATURE: {
        2023: {
            BOP: '129',
            Analytics: '130',
            Eureka: '131',
            Workspace: '132',
        },
        2024: {
            BOP: '237',
            Analytics: '239',
            Eureka: '235',
            Workspace: '238',
        },
        2025: {
            BOP: '279',
            Analytics: '280',
            Eureka: '281',
        },
        2026: {
            BOP: '304',
            Analytics: '305',
            Eureka: '306',
        },
    },
    /**
     * 产品资源位
     */
    SUPERSET_PRODUCT_RESOURCE_SPACE: 230,
    /**
     * 邮件
     */
    SUPERSET_EMAIL: 219,
    /**
     * 通知中心
     */
    SUPERSET_NOTIFICATION_CENTER: 266,
};
export const SUPERSET_CN_Features = {
    /**
     * 产品资源位
     */
    SUPERSET_PRODUCT_RESOURCE_SPACE: 230,
    /**
     * 邮件
     */
    SUPERSET_EMAIL: 219,
    /**
     * 通知中心
     */
    SUPERSET_NOTIFICATION_CENTER: 266,
};
export const SUPERSET_US_Features = {
    /**
     * 产品资源位
     */
    SUPERSET_PRODUCT_RESOURCE_SPACE: 126,
    /**
     * 邮件
     */
    SUPERSET_EMAIL: 125,
    /**
     * 通知中心
     */
    SUPERSET_NOTIFICATION_CENTER: 127,
};
export const SUPERSET_EU_Features = {
    /**
     * 产品资源位
     */
    SUPERSET_PRODUCT_RESOURCE_SPACE: 126,
    /**
     * 邮件
     */
    SUPERSET_EMAIL: 125,
    /**
     * 通知中心
     */
    SUPERSET_NOTIFICATION_CENTER: 127,
};
